/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OrderForm from '../../containers/OrderFormWrapper/Form/Form';
import OrderFormEmptyPlaceholder from './OrderFormEmptyPlaceholder';
import * as media from '../../constants/mediaQueries';

class OrderFormWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderFormMobileStyles: {},
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const cookiesAccepted = localStorage.getItem('cookiesAccepted') || false;

      this.setState({
        orderFormMobileStyles: {
          maxHeight: `calc(100vh ${cookiesAccepted ? '- 45px' : '- 124px'})`,
        },
      });
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const {
      droppingAnimation,
      flyingAnimation,
      animatedLocation,
    } = this.props;

    if (droppingAnimation !== prevProps.droppingAnimation) {
      if (droppingAnimation) {
        this.startDropingAnimation();
      }
    }

    if (flyingAnimation !== prevProps.flyingAnimation) {
      if (flyingAnimation) {
        this.startFlyingAnimation(animatedLocation);
      }
    }
  }

  startFlyingAnimation = (animatedLocation) => {
    const animatedElement = document.getElementById(this.props.animatedLocation.loc_id);
    const animatedElementCoordinates = animatedElement.getBoundingClientRect();
    const animatedElementClone = animatedElement.cloneNode(true);

    const animatedElementDestination = document.getElementById('flying-destination');
    const animatedElementDestinationCoordinates = animatedElementDestination.getBoundingClientRect();

    animatedElementClone.classList.add('flying-element');

    animatedElementClone.style.width = `${animatedElementCoordinates.width}px`;
    animatedElementClone.style.height = `${animatedElementCoordinates.height}px`;

    animatedElementClone.style.top = `${animatedElementCoordinates.top}px`;
    animatedElementClone.style.left = `${animatedElementCoordinates.left}px`;

    document.body.appendChild(animatedElementClone);

    setTimeout(() => {
      animatedElementClone.style.top = `${animatedElementDestinationCoordinates.top}px`;
      animatedElementClone.style.left = `${animatedElementDestinationCoordinates.left}px`;
      animatedElementClone.style.transform = 'scale(0.1)';
    }, 10);

    setTimeout(() => {
      this.props.flyingAnimationFinish(animatedLocation);
      animatedElementClone.parentNode.removeChild(animatedElementClone);
    }, 1000);

    setTimeout(() => {
      this.finishDroppingAnimation();
    }, 1500);
  };

  startDropingAnimation = () => {
    if (window.innerWidth < media.SCREEN_SM_MAX) {
      this.props.flyingAnimationStart();

      return;
    }

    this.props.flyingAnimationStart();

    // const orderForm = document.getElementsByClassName('js-order-form')[0];
    // const orderFormTopOffset = orderForm.getBoundingClientRect().top;
    // const headerHeight = 100;
    //
    // if (orderFormTopOffset < headerHeight) {
    //   const orderFormMarginTop = Math.abs(orderFormTopOffset) + headerHeight + 10;
    //
    //   orderForm.style.marginTop = `${orderFormMarginTop}px`;
    //   this.props.flyingAnimationStart()
    //   setTimeout(() => {
    //     this.props.flyingAnimationStart();
    //   }, 1200);
    // } else {
    //   this.props.flyingAnimationStart();
    // }
  };

  finishDroppingAnimation = () => {
    this.props.droppingAnimationFinish();
    const orderForm = document.getElementsByClassName('js-order-form')[0];

    orderForm.style.marginTop = '0px';
  };

  render() {
    const {
      removeLocationFromOrder,
      selectedLocations,
      flyingAnimation,
      droppingAnimation,
      animatedLocation,
      countryCode,
      guide,
      policy,
      formAuthToken,
      noScroll,
      handleClose,
    } = this.props;

    const isMobile = window.innerWidth < media.SCREEN_SM_MAX;
    const showForm = isMobile ? (selectedLocations.length > 0) : true;

    return (
      <div
        className={`order-form__wrapper ${selectedLocations.length === 0 && 'order-form__wrapper--empty'} ${!noScroll ? 'sticky' : ''}`}
        style={isMobile ? this.state.orderFormMobileStyles : {}}
      >
        { isMobile && <div className="order-form__close-btn" onClick={handleClose} />}
        {(isMobile && selectedLocations.length === 0) && (
          <OrderFormEmptyPlaceholder
            guide={guide}
            policy={policy}
          />
        )}
        {showForm && (
          <OrderForm
            guide={guide}
            policy={policy}
            countryCode={countryCode}
            removeLocationFromOrder={removeLocationFromOrder}
            selectedLocations={selectedLocations}
            droppingAnimation={droppingAnimation}
            animatedLocation={animatedLocation}
            flyingAnimation={flyingAnimation}
            formAuthToken={formAuthToken}
            noScroll={noScroll}
            isMobile={isMobile}
          />
        )}
      </div>
    );
  }
}

OrderFormWrapper.propTypes = {
  droppingAnimation: PropTypes.bool,
  flyingAnimation: PropTypes.bool,
  animatedLocation: PropTypes.oneOfType([PropTypes.object]),
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  removeLocationFromOrder: PropTypes.func,
  droppingAnimationFinish: PropTypes.func,
  flyingAnimationStart: PropTypes.func,
  flyingAnimationFinish: PropTypes.func,
  countryCode: PropTypes.string,
  guide: PropTypes.string,
  policy: PropTypes.string,
  formAuthToken: PropTypes.string,
  noScroll: PropTypes.bool,
  handleClose: PropTypes.func,
};

OrderFormWrapper.defaultProps = {
  selectedLocations: [],
  droppingAnimation: false,
  flyingAnimation: false,
  animatedLocation: {},
  removeLocationFromOrder: () => true,
  droppingAnimationFinish: () => true,
  flyingAnimationStart: () => true,
  flyingAnimationFinish: () => true,
  handleClose: () => true,
  countryCode: '',
  guide: '',
  policy: '',
  formAuthToken: '',
  noScroll: false,
};

export default OrderFormWrapper;
